/* VisualViewport also follows the keyboard and older mobile browser toolbars. */
(function () {
  var pending = false;
  function update() {
    pending = false;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var viewport = window.visualViewport;
    drawer.style.setProperty('--cart-viewport-height', (viewport ? viewport.height : window.innerHeight) + 'px');
    drawer.style.setProperty('--cart-viewport-top', (viewport ? viewport.offsetTop : 0) + 'px');
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(update);
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule);
  }
  document.addEventListener('cart:open', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
